"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.application = void 0;
var application_src_1 = require("./application.src");
Object.defineProperty(exports, "application", { enumerable: true, get: function () { return application_src_1.application; } });



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/application/application.controls.tsx
// module id = 526
// module chunks = 0